import { magicLinkClient, organizationClient, twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

// Better Auth requires an ABSOLUTE base URL that includes the auth mount path.
// Server is configured with basePath '/auth' (apps/api/src/auth.ts), nginx
// proxies '/api/*' → 'api:3000/*', so the client must hit '/api/auth/*' which
// the server treats as '/auth/*' (basePath stripped).
//
// The client SDK has no `basePath` option — it always appends endpoint paths
// to baseURL verbatim. Therefore baseURL must include the '/auth' suffix.
const apiOrigin =
  import.meta.env.VITE_API_URL && /^https?:\/\//.test(import.meta.env.VITE_API_URL)
    ? import.meta.env.VITE_API_URL
    : typeof window !== 'undefined'
      ? `${window.location.origin}/api`
      : 'http://localhost:3000';
const baseURL = `${apiOrigin}/auth`;

export const authClient = createAuthClient({
  baseURL,
  plugins: [magicLinkClient(), twoFactorClient(), organizationClient()],
});

export const { useSession, signIn, signUp, signOut, requestPasswordReset, resetPassword } =
  authClient;

// Build cache bust: ensures Turnstile site key build-arg propagates after var move.
